import { useCustomSnackbar } from '@procureai/ui-mui';
import { useEffect } from 'react';
import { useInstantSearch } from 'react-instantsearch';

export const SearchErrorNotification = () => {
  const { addMiddlewares } = useInstantSearch();
  const { enqueueErrorSnackbar } = useCustomSnackbar();

  useEffect(() => {
    return addMiddlewares(({ instantSearchInstance }) => {
      return {
        subscribe() {
          instantSearchInstance.addListener('error', enqueueErrorSnackbar);
        },
        unsubscribe() {
          instantSearchInstance.removeListener('error', enqueueErrorSnackbar);
        },
      };
    });
  }, [addMiddlewares, enqueueErrorSnackbar]);

  return null;
};
